import React from 'react';
export function EnglishImprintContent() {
  return <div className="prose prose-invert max-w-none" data-id="element-60">
      <section className="mb-8" data-id="element-61">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-62">
          Company details
        </h2>
        <p className="text-gray-400 leading-relaxed" data-id="element-63">
          CRM Kraft LLC
          <br data-id="element-64" />
          Represented by: Justus Kraft
          <br data-id="element-65" />
          7901 4th St. N, Ste. 300
          <br data-id="element-66" />
          St. Petersburg, FL 33702
          <br data-id="element-67" />
          United States of America
        </p>
      </section>

      <section className="mb-8" data-id="element-68">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-69">Contact</h2>
        <p className="text-gray-400 leading-relaxed" data-id="element-70">
          Phone: +49 157 35999071
          <br data-id="element-71" />
          Email: justus@crm-kraft.de
        </p>
      </section>

      <section className="mb-8" data-id="element-72">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-73">
          EU dispute resolution
        </h2>
        <p className="text-gray-400 leading-relaxed" data-id="element-74">
          The European Commission provides a platform for online dispute
          resolution (ODR):{' '}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-75">
            https://ec.europa.eu/consumers/odr/
          </a>
          .<br data-id="element-76" />
          You can find our email address above in this imprint.
        </p>
      </section>

      <section data-id="element-77">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-78">
          Consumer dispute resolution
        </h2>
        <p className="text-gray-400 leading-relaxed" data-id="element-79">
          We are neither willing nor obliged to participate in dispute
          resolution proceedings before a consumer arbitration board.
        </p>
      </section>
    </div>;
}